import { OrganisationUnitEntryRemoteDto } from '../../../../../generated/swagger';
import { LongRunningAction } from '../../../server-communication/running-actions/types/longRunningAction.decorator';
import { LongRunningContextCategoryTyp } from '../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';

export class DirectoryStructureLoaded {
   public static readonly type = '[DirectoryStructure] directory structure loaded';

   constructor(public resultEntries: OrganisationUnitEntryRemoteDto[], public directoryStructureId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.DIRECTORY_SEARCH)
export class LoadDirectoryStructure {
   public static readonly type = '[DirectoryStructure] load directory structure';

   constructor() {}
}
